<template>
  <div class="app-container column-view">

    <el-form label-width="100px" label-position="right"  class="white-block-view-5px padding-20 column-view padding-bottom-0">
      <div class="row-view">
        <el-form-item label="职务名称" class="row-item">
          <el-input v-model="searchData.name" prefix-icon="el-icon-search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" class="row-item">
          <TimeFilter style="width: 100%" ref="time" @onTime="onTimeSelect"></TimeFilter>
        </el-form-item>
        <div class="row-item"></div>
      </div>
      <div class="row-view">
        <el-form-item label="" class="row-view">
          <div class="row-view">
            <el-button type="primary" icon="el-icon-search" @click="onSearchClick">查询</el-button>
            <el-button type="default"  icon="el-icon-refresh-right"  @click="onResetClick">重置</el-button>
            <div class="margin-left-30">
              <el-button type="success"  icon="el-icon-plus"  @click="onCreatePostClick" class="margin-left-30">新增职务</el-button>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div class="white-block-view-5px margin-top-15 padding-15">
      <el-table :data="list"  v-loading="loading" border size="small" style="min-height: 500px" empty-text="暂没有职务数据哦~" >
        <el-table-column label="序号" align="center" width="100px">
          <template slot-scope="scope">
            <div>{{scope.$index+1}}</div>
          </template>
        </el-table-column>
        <el-table-column label="职务名称" prop="post_name" align="center">
        </el-table-column>
        <el-table-column label="角色属性" prop="post_attribute" align="center">
        </el-table-column>
        <el-table-column label="职务级别" prop="post_level" align="center">
        </el-table-column>
        <el-table-column label="职务说明" prop="des" align="center">
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" style="min-width: 250px">
          <template slot-scope="scope">
            <div style="width: 100%" class="row-view center-view">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="onPostEditClick(scope.row)">编辑</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="onPostDeleteClick(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <template #empty>
          <yc-no-content des="暂没有相关职务哦~"></yc-no-content>
        </template>
      </el-table>

      <el-pagination
        :current-page="searchData.page"
        :page-size="searchData.limit"
        :total="total"
        layout="total, prev, pager, next"
        style="float: right; margin-top: 40px"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <create-add-edit-post-dialog ref="createEditPostDialog" @onRefreshData="onSearchClick"></create-add-edit-post-dialog>
  </div>
</template>

<script>
//职级管理
import TimeFilter from "@/components/common/TimeFilter";
import createAddEditPostDialog from "@/views/setting/jobGradeManagement/components/createAddEditPostDialog";
export default {
  name: "JobGradeManagement",
  components: {TimeFilter,createAddEditPostDialog},
  data() {
    return {
      searchData:{
        page:1,
        limit:20,
        name:"",
        created_from: '',//起始时间
        created_to: '',//结束时间
      },
      total:0,
      loading:false,
      list:[

      ]

    }
  },
  methods: {

    handleCurrentChange(val){
      this.searchData.page = val;
      this.onSearchClick();
    },
    onTimeSelect(value){
      this.searchData.created_from = value[0] || ''
      this.searchData.created_to = value[1] || ''
    },

    onPostEditClick(item){
      this.$refs.createEditPostDialog.setData({
        post_name:item.post_name,
        post_id:item.id,
        post_note:item.post_note||'',
        post_attribute:item.post_attribute,
      })
    },

    onCreatePostClick(){
      this.$refs.createEditPostDialog.showDialog();
    },

    onPostDeleteClick(item){
      console.log('点击删除按钮了')
      this.$prompt('确认删除当前职务【'+item.post_name+'】?', '删除职务', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            this.http.api('deletePost', { id: item.id }).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
                done()
                this.$commonUtils.showMessage('操作成功','success')
                this.onSearchClick();
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '删除'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })
    },
    onSearchClick(){
        this.loading=true;
        this.http.api('postList',this.searchData)
            .then(res=>{
              this.loading=false
              if(res.status){
                let mainData = res.data;
                this.total = mainData.total;
                this.list = mainData.data;
              }else{
                this.$commonUtils.showMessage(res.message,'error')
              }
            })
            .catch(error=>{
              this.loading=false
            })
    },


    onResetClick(){
      this.searchData.name='';
      this.searchData.created_from='';
      this.searchData.created_to='';
      this.searchData.page=1;
      this.$refs.time.onClear()
      this.onSearchClick();
    },
  },
  created() {
    this.onSearchClick();
  }
}
</script>

<style scoped>

</style>
